const Host = 'https://xcwh-1327518518.cos.ap-chengdu.myqcloud.com/';
const tempHost = 'https://admin.xichuanwh.com/';
//const tempHost = 'http://read.com/';
export default{
	Host,
	tempHost
}